import script from "./RepairOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./RepairOrder.vue?vue&type=script&setup=true&lang=js"

import "./RepairOrder.vue?vue&type=style&index=0&id=1adb4346&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1adb4346"]])

export default __exports__